(function () {
  'use strict';

  // tfc.Nav is defined in tfc-sso
  angular
      .module('tfc.Nav')
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('pageWithMenu', {
          parent : 'page',
          abstract : true,
          templateUrl : 'Nav/PageWithMenu.tmpl.html',
          controller: 'PageWithMenuCtrl as vm',
          onEnter: function (LookAndFeel, LookAndFeelType, GaUtil) {
            if(!LookAndFeel.isBrandMetrics()) {
              GaUtil.setGaDimension('dimension2', LookAndFeelType.BrandMetrics);
              LookAndFeel.setToBrandMetrics();
            }
          }
        });
  }

})();
